import React, { useState } from 'react';
import { Dialog, Box, Typography, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CommonImages from '../../commons/images';
import GoogleMark from '../components/svgs/googleMark';
import OutlookMark from '../components/svgs/outlookMark';
import useLoginDialog from './useLoginDialog';
import * as styles from './styles';

function LoginDialog({ open, publisher, onClose }) {
    const [email, setEmail] = useState('');
    const { googleOauth, outlookOauth, type } = useLoginDialog();

    const publisherLabel = publisher?.publisherName
        ? `Sync ${publisher.publisherName}`
        : 'Sync to your calendar';

    function handleEmailSubmit(e) {
        e.preventDefault();
        if (email) {
            // email auth — to be wired to env flow later
            onClose();
        }
    }

    function renderHeader() {
        return (
            <Box sx={styles.header}>
                <Box component="img" src={CommonImages.ECAL_SYMBOL} alt="ECAL" sx={styles.symbol} />
                <Typography sx={styles.title}>{publisherLabel}</Typography>
            </Box>
        );
    }

    function renderSubtitle() {
        return (
            <Typography sx={styles.subtitle}>
                Sign in to add this publisher's events to your personal digital calendar.
                You don't need an ECAL account — Google or Outlook is enough.
            </Typography>
        );
    }

    function renderGoogleButton() {
        if (type === 'outlook') return null;
        return (
            <Box
                component="button"
                onClick={googleOauth}
                sx={styles.providerButton(false)}
            >
                <GoogleMark />
                Continue with Google
            </Box>
        );
    }

    function renderOutlookButton() {
        if (type === 'google') return null;
        return (
            <Box
                component="button"
                onClick={outlookOauth}
                sx={styles.providerButton(true)}
            >
                <OutlookMark />
                Continue with Outlook
            </Box>
        );
    }

    function renderDivider() {
        return (
            <Box sx={styles.dividerRow}>
                <Box component="hr" sx={styles.dividerLine} />
                <Typography sx={styles.dividerLabel}>or</Typography>
                <Box component="hr" sx={styles.dividerLine} />
            </Box>
        );
    }

    function renderEmailForm() {
        return (
            <Box component="form" onSubmit={handleEmailSubmit}>
                <Box component="label">
                    <Typography component="span" sx={styles.emailLabel}>
                        Email address
                    </Typography>
                    <Box
                        component="input"
                        type="email"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="you@example.com"
                        sx={styles.emailInput}
                    />
                </Box>
                <Button variant="contained" type="submit" sx={styles.submitButton}>
                    Continue with email
                </Button>
            </Box>
        );
    }

    function renderLegal() {
        return (
            <Typography sx={styles.legal}>
                By continuing you agree to ECAL's{' '}
                <Box component="a" href="https://ecal.com/terms-of-use/" target="_blank" rel="noreferrer" sx={styles.legalLink}>
                    Terms
                </Box>
                {' '}and{' '}
                <Box component="a" href="https://ecal.com/privacy-policy/" target="_blank" rel="noreferrer" sx={styles.legalLink}>
                    Privacy Policy
                </Box>.
                {' '}OAuth tokens are stored server-side in secure httpOnly sessions.
            </Typography>
        );
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={false}
            aria-label="Sign in to sync"
            sx={styles.dialog}
            slotProps={{
                backdrop: { sx: styles.backdrop },
            }}
        >
            <Button onClick={onClose} aria-label="Close" sx={styles.closeButton}>
                <CloseIcon sx={{ fontSize: 18 }} />
            </Button>

            {renderHeader()}
            {renderSubtitle()}
            {renderGoogleButton()}
            {renderOutlookButton()}
            {renderDivider()}
            {renderEmailForm()}
            {renderLegal()}
        </Dialog>
    );
}

export default LoginDialog;
